import { render } from "./Sidebar.vue?vue&type=template&id=3d176d55&scoped=true"
const script = {}

import "./Sidebar.vue?vue&type=style&index=0&id=3d176d55&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d176d55"]])

export default __exports__